<template>
    <!-- Modal -->
    <div class="modal fade" id="addUpdateAdOnsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="addUpdateAdOnsModalLabel">Add / Update Ad'On(s) of {{resName}}</h4>
                </div>
                <form method="post" @submit.prevent="addUpdateAdOnCategories()">
                    <div class="modal-body">
                        <ul class="list-unstyled adonbody">
                            <li style="margin-bottom: 10px"><button type="button" class="btn btn-primary btn-xs" v-on:click="addNewAdOnCategory()">Add New Ad On Category</button></li>
                            <li v-for="(adOnCategory,adOnCategoryIndex) in adOnCategories" v-bind:key="adOnCategoryIndex">
                                <div class="row">
                                    <hr/>
                                    <div class="col-md-6">
                                        <label ><b class="text-success"> {{adOnCategory.name}}</b></label>
                                        <input v-model="adOnCategory.id" type="hidden" />
                                        <div class="input-group m-b">
                                            <span class="input-group-addon"><a title="Add New Ad On Item" class="myTip"  v-on:click="addNewAdOnItem(adOnCategory.addOnItemsById)"><i class="fa fa-plus"></i></a></span>
                                            <span class="input-group-addon" v-if="adOnCategory.id === 0"><a class="myTip" title="Remove This Category" v-on:click="removeFromObject(adOnCategoryIndex, adOnCategories)"><i class="fa fa-times"></i></a></span>
                                            <input v-model="adOnCategory.name" type="text" class="form-control" placeholder="New Ad On Category ..." />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Allowed Items</label >
                                        <input v-model="adOnCategory.allowedItems" type="number"  min="1" class="form-control" placeholder="Allowed Items Of This Category ..." />
                                    </div>
                                    <div class="col-md-3 style-buttons">
                                        <a>
                                          <i v-if="!adOnCategory.required"
                                              class="fa fa-check-circle-o fa-lg"
                                             title="Mark Category as Required"
                                             @click="adOnCategory.required=true"
                                          />
                                          <i v-else class="fa fa-check-circle fa-lg"
                                             title="Unmark Category as Required"
                                             @click="adOnCategory.required=false"
                                          />
                                        </a> |
                                        <a>
                                          <i v-if="adOnCategory.disableDiscount"
                                             class="fa fa-toggle-off fa-lg"
                                             title="Enable Discount"
                                              @click="adOnCategory.disableDiscount=false"
                                          />
                                          <i v-else class="fa fa-toggle-on fa-lg"
                                             title="Disable Discount"
                                             @click="adOnCategory.disableDiscount=true"
                                          />
                                        </a>
                                        <a v-if="adOnCategory.id > 0 && userRole === 'ROLE_ADMIN'">
                                          | <i class="fa fa-trash-o fa-lg"
                                             title="Delete Add Category"
                                             @click="deleteAddOnCategory(adOnCategory.id, resId, resName, adOnCategory.addOnItemsById, adOnCategoryIndex, adOnCategories)"
                                          />
                                        </a>
                                      </div>
                                    </div>
                                <ul class="list-unstyled">
                                    <li v-for="(adOnItem,indexAdOnItem) in adOnCategory.addOnItemsById" v-bind:key="indexAdOnItem">
                                        <div class="row">
                                            <div class="col-md-5 col-md-offset-1">
                                                <label>Name</label>
                                                <input v-model="adOnItem.id" type="hidden" />
                                                <div class="input-group m-b">
                                                    <span class="input-group-addon" v-if="adOnItem.id === 0"><a class="myTip" title="Remove This Item" v-on:click="removeFromObject(indexAdOnItem, adOnCategory.addOnItemsById)"><i class="fa fa-times"></i></a></span>
                                                    <input v-model="adOnItem.name" type="text" class="form-control" placeholder="Ad On Item ..." />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <label>Price</label>
                                                <input v-model="adOnItem.price" type="number" class="form-control" placeholder="Ad On Item Price ..." />
                                            </div>
                                            <div v-if="userRole === 'ROLE_ADMIN'">
                                              <div class="col-md-2 style-buttons">
                                                <br/><br/>
                                                <a title="Delete AdOn Item" v-on:click="deleteAddOnItem(adOnItem.id, resId, resName, indexAdOnItem, adOnCategory.addOnItemsById)">
                                                  <b class="fa fa-trash-o fa-lg"/>
                                                </a>
                                              </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import MenuValidation from "../../Mixins/MenuValidation";

    export default {
        name: "AddUpdateAdOns",
        mixins: [MenuValidation],
        data() {
            return {
                resName: "",
                resId: "",
                adOnCategories:[],
                userRole: "",
            }
        },
        updated: function (){
            $(".myTip").tooltip({
                placement: "right"
            });
        },
        mounted: function () {
            $("#addUpdateAdOnsModal").on('hidden.bs.modal',  (e) => {
                this.adOnCategories = [];
            });
            this.userRole = this.$store.getters.user.userRolesById[0].role;
        },
        methods: {
            load: function (restaurantId, restaurantName){
                this.resName = restaurantName;
                this.resId = restaurantId;
                let params = new URLSearchParams();
                params.append("restaurant_id", restaurantId);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_ad_on_categories", params).then(resp => {
                    this.adOnCategories = resp.data;
                    for(let i = 0; i < this.adOnCategories.length; i++){
                        this.adOnCategories[i].restaurantsByRestaurantId = {
                            id: restaurantId
                        }
                    }
                    $("#addUpdateAdOnsModal").modal("show");
                });
            },
            removeFromObject: function (index, object) {
                object.splice(index, 1);
            },
            addNewAdOnCategory: function () {
                let newCategory = {
                    id: 0,
                    name: "",
                    allowedItems: 1,
                    required: false,
                    addOnItemsById: [],
                    restaurantsByRestaurantId: {
                        id:this.resId
                    }
                };
                this.adOnCategories.push(newCategory);
            },
            addNewAdOnItem: function (object) {
                let newObj = {
                    id: 0,
                    name: "",
                    price: 0
                };
                object.push(newObj);
            },
            addUpdateAdOnCategories:function () {
                for(let adOnCat of this.adOnCategories){
                    if(adOnCat.allowedItems === 0){
                        return swal("Error!", "0 allowed item is not allowed! Please correct it in: " + adOnCat.name, "error");
                    }
                }
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.post(this.$store.state.mainAppURL + "restaurants/add_update_restaurant_ad-ons", this.adOnCategories).then(resp => {
                    if(resp.data){
                        $("#addUpdateAdOnsModal").modal("hide");
                        Swal.close();
                        swal("SUCCESS!", "Ad Ons has been added / updated", "success");
                    }else{
                        swal("ERROR!", "Please try again or contact DVM Tech Support", "error");
                    }
                });
            }
        }
    }
</script>

<style scoped>
.adonbody{
    height: 780px;
    overflow-x: hidden;
    overflow-y: auto;
}
.style-buttons{
  padding-bottom: 15px;
}
</style>
